var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCaretUp = function SvgIconCaretUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343330",
    d: "M19.924 16.425a1.125 1.125 0 0 1-1.594 0l-6.702-6.703-6.704 6.703A1.127 1.127 0 1 1 3.33 14.83l7.5-7.5a1.125 1.125 0 0 1 1.594 0l7.5 7.5a1.125 1.125 0 0 1 0 1.594"
  })));
};
export default SvgIconCaretUp;